var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistHovered = function SvgWishlistHovered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.643 2.917 11 3.28l.357-.364C13.628.6 16.208.107 18.163.774c1.95.667 3.383 2.518 3.336 5.14-.042 2.306-1.633 4.699-3.791 6.848-2.14 2.13-4.743 3.929-6.617 5.044a.167.167 0 0 1-.182 0c-1.874-1.115-4.477-2.914-6.616-5.043C2.134 10.613.543 8.22.5 5.915.453 3.293 1.886 1.44 3.836.775 5.791.107 8.371.599 10.643 2.917Z",
    fill: "#fff",
    stroke: "#069BAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.923,
    cy: 12.923,
    r: 5.423,
    fill: "#fff",
    stroke: "#069BAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.714 11.136a.464.464 0 0 0-.656 0l-2.953 2.953-1.313-1.312a.464.464 0 0 0-.656.656l1.64 1.64a.463.463 0 0 0 .657 0l3.281-3.28a.464.464 0 0 0 0-.657Z",
    fill: "#000"
  })));
};
export default SvgWishlistHovered;